import React from "react";

import styled from "styled-components";
import theme from "../../styles/theme";

import Hero from "../basic/Hero";

const {
	colors,
	breakPoints: { screenQuery },
} = theme;

const StyledHero = styled(Hero)`
	padding-top: 0;
	${screenQuery.medium} {
		padding-top: 50px;
	}

	div {
		justify-content: flex-start;
		margin-left: 0;
		grid-template-columns: auto;
		margin-top: 20px;
	}
`;

const SupportHero = ({
	headerText,
	subHeaderText,
	heroImage,
	bottomSpace,
	heroButtons,
}) => {
	return (
		<StyledHero
			header={headerText}
			subheader={subHeaderText}
			image={heroImage}
			topBottomSpace={bottomSpace}
			buttons={heroButtons}
		/>
	);
};

export default SupportHero;
